export default __webpack_public_path__ + "static/media/hdfc-client.59782da2.webp";